<div
  (mouseover)="onMouseOver()"
  (mouseout)="onMouseOut()"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  {{ (row()?.shares?.length < 10 ? '\u00A0' : '') + (row()?.shares?.length || '') }}
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen()"
  >
    <mat-card>
      <mat-card-content class="user-count">
        @for (share of shares(); track share.email) {
          {{ share.email }}
          <span
            class="user-count__role"
            [ngClass]="{
              'user-count__admin': share.role === 'DATA_MANAGER' || share.role === 'DEVICE_MANAGER',
              'user-count__owner': share.role === 'OWNER',
            }"
          >
            ({{ Translator.role(share.role) }})
          </span>
        }
      </mat-card-content>
    </mat-card>
  </ng-template>
</div>
